export default __webpack_public_path__ + "d36f825de245fd731120d073d90dae32.svg";